module.exports = __webpack_public_path__ + "img/load.236d6026.svg";